import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

import { createVuetify } from 'vuetify/lib/framework'
import { VCard } from 'vuetify/lib/components'
import * as directives from 'vuetify/lib/directives'

export default createVuetify({
  components: {
    VCard
  },
  directives,
  theme: {
    defaultTheme: 'dark',
    themes: {
      dark: {
        colors: {
          primary: '#FF206E',
          secondary: '#FF8FAF',
          accent: '#FFA600',
        }
      }
    }
  }
}) 